import { useContext, useState } from "react";
import { domain } from "../consts";
import { AlertContext } from "../context/AlertContext";

const InvitationForm2 = ({ rsvp }) => {
  const [formData, setFormData] = useState({
    guestName: "",
    phoneNumber: "",
    email: "",
    isComing: true,
    needsAccommodation: false,
    personalMessage: "",
    additionalGuests: [],
  });

  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const { handleAlert } = useContext(AlertContext);

  const textStyle = {
    color: rsvp?.textColor,
  };
  const highlightStyle = {
    color: rsvp?.highlightColor,
  };
  const inputStyle = {
    backgroundColor: rsvp?.bgColor,
    color: rsvp?.textColor,
    borderColor: rsvp?.textColor,
    "--tw-ring-color": rsvp?.textColor,
    backgroundOpacity: 0.2,
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setSubmitSuccess(null);

    try {
      const response = await fetch(`${domain}/response/${rsvp.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (response.ok) {
        setSubmitSuccess(data.message || "Form successfully submitted!");
        setFormData({
          guestName: "",
          phoneNumber: "",
          email: "",
          isComing: false,
          needsAccommodation: false,
          personalMessage: "",
          additionalGuests: [],
        });
      } else {
        if (response.status === 403) {
          throw new Error("Nažalost, dosegnut je maksimalan broj gostiju.");
        }
        throw new Error("Došlo je do greške prilikom slanja forme.");
      }
    } catch (error) {
      handleAlert(error.message, "error");
    } finally {
      setSubmitting(false);
    }
  };
  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;

    const inputValue = type === "checkbox" ? checked : value;
    setFormData({ ...formData, [name]: inputValue });
  };

  const addAdditionalName = () => {
    setFormData({
      ...formData,
      additionalGuests: [...formData.additionalGuests, ""],
    });
  };

  const handleRemoveName = (index) => {
    setFormData({
      ...formData,
      additionalGuests: formData.additionalGuests.filter((_, i) => i !== index),
    });
  };

  const handleAdditionalNameChange = (index, value) => {
    const updatedNames = [...formData.additionalGuests];
    updatedNames[index] = value;
    setFormData({ ...formData, additionalGuests: updatedNames });
  };

  return (
    <div
      className={`bg-[url('/path-to-your-background-image.jpg')] bg-cover my-12 font-${rsvp.textFont}`}
    >
      <div className="max-w-lg p-8 mt-10 rounded-lg min-h-96 mx-4 sm:mx-auto">
        {submitSuccess ? (
          <div className="flex items-center justify-center pb-10">
            <p className="text-4xl font-bold text-gray-500">
              Hvala na potvrdi!
            </p>
          </div>
        ) : (
          <>
            <h2
              className="text-xl md:text-2xl lg:text-4xl text-center mb-4 font-display italic"
              style={textStyle}
            >
              Potvrdite svoj dolazak
            </h2>
            <p className="text-center mb-8 text-xl italic" style={textStyle}>
              do{" "}
              {new Date(rsvp?.formExpiryDate).toLocaleDateString("hr-HR", {
                day: "numeric",
                month: "long",
                year: "2-digit",
              })}
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <input
                  type="text"
                  id="guestName"
                  name="guestName"
                  placeholder="Ime i prezime"
                  value={formData.guestName}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-500 rounded-md"
                  style={inputStyle}
                />
              </div>

              <div className={`flex ${!rsvp?.includePhone && "hidden"}`}>
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Telefon"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="w-full p-3 border border-gray-500 rounded-md text-gray-800"
                  style={inputStyle}
                />
              </div>

              <div className={`flex ${!rsvp?.includeEmail && "hidden"}`}>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email adresa"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-3 border border-gray-500 rounded-md text-gray-800"
                  style={inputStyle}
                />
              </div>

              {/* <div className="flex"> */}
              {/*   <input */}
              {/*     type="checkbox" */}
              {/*     name="isComing" */}
              {/*     onChange={handleChange} */}
              {/*     className="shrink-0 mt-0.5 border-gray-200 rounded text-gray-500 focus:ring-gray-500 cursor-pointer disabled:opacity-50 disabled:pointer-events-none      :bg-blue-500  :border-blue-500  :ring-offset-gray-800" */}
              {/*     id="hs-default-checkbox" */}
              {/*   /> */}
              {/*   <label */}
              {/*     htmlFor="hs-default-checkbox" */}
              {/*     className="text-gray-500 ms-3  " */}
              {/*   > */}
              {/*     {formData.additionalGuests.length ? "Dolazimo!" : "Dolazim!"} */}
              {/*   </label> */}
              {/* </div> */}
              <div className={`flex ${!rsvp?.formAccommodation && "hidden"}`}>
                <input
                  disabled={!formData.isComing}
                  type="checkbox"
                  name="needsAccommodation"
                  onChange={handleChange}
                  className="shrink-0 mt-0.5 border-gray-200 rounded cursor-pointer disabled:opacity-50 disabled:pointer-events-none"
                  style={inputStyle}
                  id="hs-default-checkbox"
                />
                <label
                  htmlFor="hs-default-checkbox"
                  className="ms-3  "
                  style={textStyle}
                >
                  {formData.additionalGuests.length
                    ? "Trebamo smjestaj"
                    : "Trebam smjestaj"}
                </label>
              </div>

              {formData.additionalGuests.map((guestName, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <input
                    type="text"
                    placeholder="Ime i prezime"
                    value={guestName}
                    onChange={(e) =>
                      handleAdditionalNameChange(index, e.target.value)
                    }
                    required
                    className="w-full p-3 border border-gray-500 rounded-md flex-1"
                    style={inputStyle}
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveName(index)}
                    className="text-red-500 hover:text-red-700 text-4xl"
                  >
                    &times;
                  </button>
                </div>
              ))}

              <div className="text-center">
                <button
                  type="button"
                  onClick={addAdditionalName}
                  className="text-lg"
                  style={inputStyle}
                >
                  <p style={textStyle}>+ Ima nas još</p>
                </button>
              </div>
              <div>
                <textarea
                  type="text"
                  id="personalMessage"
                  name="personalMessage"
                  placeholder="Poruka za mladence"
                  value={formData.personalMessage}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-md"
                  style={inputStyle}
                />
              </div>

              <div className="text-center mt-8">
                <button
                  disabled={submitting}
                  type="submit"
                  className="px-6 py-2 bg-white border-gray-500 text-2xl rounded-md shadow hover:bg-yellow-100"
                  style={inputStyle}
                >
                  <p style={highlightStyle}>Pošalji</p>
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default InvitationForm2;
